var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 0C2.78103 0 2.33333 0.447717 2.33333 1H1C0.4477 1 0 1.44772 0 2V12.3333C0 12.8856 0.4477 13.3333 1 13.3333H8.33333C8.88563 13.3333 9.33333 12.8856 9.33333 12.3333V2C9.33333 1.44772 8.88563 1 8.33333 1H7C7 0.447717 6.5523 0 6 0H3.33333ZM3 1C3 0.815907 3.14923 0.666667 3.33333 0.666667H6C6.1841 0.666667 6.33333 0.815907 6.33333 1V1.66667C6.33333 1.85076 6.1841 2 6 2H3.33333C3.14923 2 3 1.85076 3 1.66667V1ZM3 3.66667V4.66667H2V5.33333H3V6.33333H3.66667V5.33333H4.66667V4.66667H3.66667V3.66667H3ZM2.33333 7.33333C2.14923 7.33333 2 7.48257 2 7.66667C2 7.85077 2.14923 8 2.33333 8H7C7.1841 8 7.33333 7.85077 7.33333 7.66667C7.33333 7.48257 7.1841 7.33333 7 7.33333H2.33333ZM2 9.33333C2 9.14923 2.14923 9 2.33333 9H7C7.1841 9 7.33333 9.14923 7.33333 9.33333C7.33333 9.51743 7.1841 9.66667 7 9.66667H2.33333C2.14923 9.66667 2 9.51743 2 9.33333ZM2.33333 10.6667C2.14923 10.6667 2 10.8159 2 11C2 11.1841 2.14923 11.3333 2.33333 11.3333H7C7.1841 11.3333 7.33333 11.1841 7.33333 11C7.33333 10.8159 7.1841 10.6667 7 10.6667H2.33333Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlan);
export default __webpack_public_path__ + "static/media/icon_plan.9f7a05547177f10fddd4b4b257cbfb91.svg";
export { ForwardRef as ReactComponent };